import React, { useEffect } from "react";
import { DataTable } from "../../../DataTable/DataTable";
import { Edit, Trash } from "lucide-react";
import { ManufacturerData } from "./types";
import toast from "react-hot-toast";
import { InverntroyService } from "../../../../services/api/inventroy.service";

interface ManufacturerListProps {
  searchTerm?: string;
  setSelectedManufacturer: (data:ManufacturerData)=> void
  setShowManufacturerModal: ()=> void
}

const ManufacturerList: React.FC<ManufacturerListProps> = ({ searchTerm,setSelectedManufacturer,setShowManufacturerModal }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalItemsCount, setTotalItemsCount] = React.useState(0);
  const [wholesalerData, setWholesalerData] = React.useState<ManufacturerData[]>(
    []
  );

  const loadWholesalerData = async (
    page: number,
    pageSize: number,
    searchTerm?: string
  ) => {
    try {
      setIsLoading(true);
      const response = await InverntroyService.getManufacturerListing(
        page,
        pageSize,
        searchTerm
      );
      if (response.success) {
        setWholesalerData(response.data);
      } else {
        toast.error(response.message);
        setWholesalerData([]);
      }
      setTotalItemsCount(response.pagination.totalItemsCount);
      setTotalPages(response.pagination.totalPages);
    } catch (error) {
      toast.error(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadWholesalerData(currentPage, pageSize, searchTerm);
  }, [currentPage, pageSize, searchTerm]);

  const handleDelteWholeSaler = async (id: string) => {
    try {
      const response = await InverntroyService.deleteManufacturer(id);

      if (response.success) {
        toast.success(response.message);
        loadWholesalerData(1, 10);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error((error as Error)?.message || "An error occurred");
    }
  };
  const columns = [
    {
      key: "WholesalerName",
      title: "Manufacturer Name",
      width: "w-[200px]",
      render: (item: ManufacturerData) => (
        <div
          className="flex items-center space-x-2 line-clamp-2 cursor-default"
          title={item.manufacturer_name}
        >
          {item.manufacturer_name || "N/A"}
        </div>
      ),
    },
    {
      key: "Address",
      title: "Address",
      width: "w-[250px]",
      render: (item: ManufacturerData) => (
        <div className="flex items-center space-x-2 line-clamp-2" title={item.manufacturer_address}>
          {item.manufacturer_address || "N/A"}
        </div>
      ),
    },
    {
      key: "Created At",
      title: "Created At",
      width: "w-[150px]",
      render: (item: ManufacturerData) => (
        <div className="flex items-center space-x-2">
          {item.created_at ? new Date(item.created_at).toISOString().split("T")[0] : "N/A"}
        </div>
      ),
    },
    {
      key: "Actions",
      title: "Actions",
      width: "w-[150px]",
      render: (item: ManufacturerData) => (
        <div className="flex space-x-4">
          <button
            className="text-yellow-500 hover:text-yellow-700"
            onClick={() => {
              setSelectedManufacturer(item);
              setShowManufacturerModal();
            }}
          >
            <Edit className="w-5 h-5" />
          </button>
          <button
            className="text-red-500 hover:text-red-700"
            onClick={() => {
              handleDelteWholeSaler(item.id);
            }}
          >
            <Trash className="w-5 h-5" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <DataTable
        data={wholesalerData}
        columns={columns}
        isLoading={isLoading}
        customFilters={[]}
        pagination={{
          currentPage,
          setCurrentPage,
          setTotalPages,
          totalPages,
          totalItemsCount,
          pageSize,
          setPageSize,
        }}
      />
    </div>
  );
};

export default ManufacturerList;
